import { AppMenuDto } from './app.model';
export const reportMenus: AppMenuDto[] = [
  {
    path: 'COMP',
    module: 'pages',
    iconClass: 'file-sync',
    requiredPolicy: 'Reports.COMP', // assumes report code COMP
  },
];
